import { render } from "./ScanButton.vue?vue&type=template&id=cfb5c848"
import script from "./ScanButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ScanButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/product-submission/components/filter/ScanButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cfb5c848"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cfb5c848', __exports__)) {
    api.reload('cfb5c848', __exports__)
  }
  
  module.hot.accept("./ScanButton.vue?vue&type=template&id=cfb5c848", () => {
    api.rerender('cfb5c848', render)
  })

}


export default __exports__